import "./Home.module.css";
import SiteHeader from "@/reusable_sections/Header";
import DignityInEveryVisit from "./sections/DignityInEveryVisit";
import OurSacredMission from "./sections/OurSacredMission";
import ImmediateSeniorAidReferral from "./sections/ImmediateSeniorAidReferral";
import ThePillarsOfOurCare from "./sections/ThePillarsOfOurCare";
import VoicesOfTheCommunity from "./sections/VoicesOfTheCommunity";
import ByTheNumbers from "./sections/ByTheNumbers";
import FoundationNewsUpdates from "./sections/FoundationNewsUpdates";
import StSampsonFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <SiteHeader />
      <DignityInEveryVisit />
      <OurSacredMission />
      <ImmediateSeniorAidReferral />
      <ThePillarsOfOurCare />
      <VoicesOfTheCommunity />
      <ByTheNumbers />
      <FoundationNewsUpdates />
      <StSampsonFooter />
    </div>;
}